import ApiService from "@/services/ApiService";

const REPOSITORY_URL = "configuracion";

const ConfiguracionRepository = {
  listaMaquina() {
    return ApiService.get(`${REPOSITORY_URL}/lista_maquina`);
  },

  crearInventario(
    idAgricultor,
    idMaquina,
    costoTotal,
    anioFabricacion,
    fechaAdquisicion,
    comentario
  ) {
    let data = {
      idAgricultor,
      idMaquina,
      costoTotal,
      anioFabricacion,
      fechaAdquisicion,
      comentario,
    };
    return ApiService.post(`${REPOSITORY_URL}/crear_inventario`, data);
  },

  actualizarInventario(
    idTemporada,
    idEstablecimiento,
    idGrupoExplotacion,
    idInventario,
    costoTotal,
    anioFabricacion,
    fechaAdquisicion,
    comentario
  ) {
    let data = {
      idTemporada,
      idEstablecimiento,
      idGrupoExplotacion,
      idInventario,
      costoTotal,
      anioFabricacion,
      fechaAdquisicion,
      comentario,
    };
    return ApiService.post(`${REPOSITORY_URL}/actualizar_inventario`, data);
  },

  debajaInventario(idInventario) {
    let data = {
      idInventario,
    };
    return ApiService.post(`${REPOSITORY_URL}/debaja_inventario`, data);
  },

  listaPersonalAgricultor(idEstablecimiento, idGrupoExplotacion) {
    let data = {
      idEstablecimiento,
      idGrupoExplotacion,
    };
    return ApiService.get(`${REPOSITORY_URL}/lista_personal_agricultor`, data);
  },

  crearPersonal(idAgricultor, nombre, costoHora) {
    let data = {
      idAgricultor,
      nombre,
      costoHora,
    };
    return ApiService.post(`${REPOSITORY_URL}/crear_personal`, data);
  },

  actualizarPersonal(
    idTemporada,
    idEstablecimiento,
    idGrupoExplotacion,
    idPersonal,
    nombre,
    costoHora
  ) {
    let data = {
      idTemporada,
      idEstablecimiento,
      idGrupoExplotacion,
      idPersonal,
      nombre,
      costoHora,
    };
    return ApiService.post(`${REPOSITORY_URL}/actualizar_personal`, data);
  },

  debajaPersonal(idPersonal) {
    let data = {
      idPersonal,
    };
    return ApiService.post(`${REPOSITORY_URL}/debaja_personal`, data);
  },

  listaZona() {
    return ApiService.get(`${REPOSITORY_URL}/lista_zona`);
  },

  crearFichaAgricola(
    idEstablecimiento,
    idGrupoExplotacion,
    idTemporada,
    idVariedad,
    nombre,
    superficie,
    comentario
  ) {
    let data = {
      idEstablecimiento,
      idGrupoExplotacion,
      idTemporada,
      idVariedad,
      nombre,
      superficie,
      comentario,
    };
    return ApiService.post(`${REPOSITORY_URL}/crear_ficha_agricola`, data);
  },

  actualizarFichaAgricola(
    idFichaAgricola,
    idVariedad,
    nombre,
    superficie,
    comentario
  ) {
    let data = {
      idFichaAgricola,
      idVariedad,
      nombre,
      superficie,
      comentario,
    };
    return ApiService.post(`${REPOSITORY_URL}/actualizar_ficha_agricola`, data);
  },

  debajaFichaAgricola(idFichaAgricola) {
    let data = {
      idFichaAgricola,
    };
    return ApiService.post(`${REPOSITORY_URL}/debaja_ficha_agricola`, data);
  },

  listaGrupoExplotacion(idAgricultor) {
    let data = {
      idAgricultor,
    };
    return ApiService.get(`${REPOSITORY_URL}/lista_grupo_explotacion`, data);
  },

  agregarGrupoExplotacion(idAgricultor, idEstablecimiento, idGrupoExplotacion) {
    let data = {
      idAgricultor,
      idEstablecimiento,
      idGrupoExplotacion,
    };
    return ApiService.post(`${REPOSITORY_URL}/agregar_grupo_explotacion`, data);
  },

  debajaGrupoExplotacion(idAgricultor, idEstablecimiento, idGrupoExplotacion) {
    let data = {
      idAgricultor,
      idEstablecimiento,
      idGrupoExplotacion,
    };
    return ApiService.post(`${REPOSITORY_URL}/debaja_grupo_explotacion`, data);
  },

  //Establecimiento
  crearEstablecimiento(idAgricultor, idZona, idGrupoExplotacionList, nombre) {
    let data = {
      idAgricultor,
      idZona,
      idGrupoExplotacionList,
      nombre,
    };
    return ApiService.post(`${REPOSITORY_URL}/crear_establecimiento`, data);
  },

  actualizarEstablecimiento(
    idAgricultor,
    idEstablecimiento,
    idZona,
    nombre,
    idGrupoExplotacion
  ) {
    let data = {
      idAgricultor,
      idEstablecimiento,
      idZona,
      nombre,
      idGrupoExplotacion,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/actualizar_establecimiento`,
      data
    );
  },

  debajaEstablecimiento(idAgricultor, idEstablecimiento) {
    let data = {
      idAgricultor,
      idEstablecimiento,
    };
    return ApiService.post(`${REPOSITORY_URL}/debaja_establecimiento`, data);
  },

  listaEstablecimientos(idAgricultor) {
    let data = {
      idAgricultor: idAgricultor,
    };
    return ApiService.get(`${REPOSITORY_URL}/lista_establecimiento`, data);
  },

  crearFichaGanadera(idEstablecimiento, idGrupoExplotacion, idTemporada) {
    let data = {
      idEstablecimiento,
      idGrupoExplotacion,
      idTemporada,
    };
    return ApiService.post(`${REPOSITORY_URL}/crear_ficha_ganadera`, data);
  },

  crearParcelaGanadera(idFichaGanadera, datosParcelaGanaderaList) {
    let data = {
      idFichaGanadera,
      datosParcelaGanaderaList,
    };
    return ApiService.post(`${REPOSITORY_URL}/crear_parcela_ganadera`, data);
  },

  actualizarParcelaGanadera(idParcelaGanadera, datosParcelaGanadera) {
    let data = {
      idParcelaGanadera,
      datosParcelaGanadera,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/actualizar_parcela_ganadera`,
      data
    );
  },

  debajaParcelaGanadera(idParcelaGanadera) {
    let data = {
      idParcelaGanadera,
    };
    return ApiService.post(`${REPOSITORY_URL}/debaja_parcela_ganadera`, data);
  },

  crearRetiro(idEstablecimiento, idGrupoExplotacion, datosRetiroList) {
    let data = {
      idEstablecimiento,
      idGrupoExplotacion,
      datosRetiroList,
    };
    return ApiService.post(`${REPOSITORY_URL}/crear_retiro`, data);
  },

  actualizarRetiro(idGrupoExplotacion, idRetiro, nombre) {
    let data = {
      idGrupoExplotacion,
      idRetiro,
      datosRetiro: {
        nombre,
      },
    };
    return ApiService.post(`${REPOSITORY_URL}/actualizar_retiro`, data);
  },

  debajaRetiro(idGrupoExplotacion, idRetiro) {
    let data = {
      idGrupoExplotacion,
      idRetiro,
    };
    return ApiService.post(`${REPOSITORY_URL}/debaja_retiro`, data);
  },

  // Conceptos
  crearConcepto(tipo, nombre) {
    let data = {
      tipo,
      nombre,
    };
    return ApiService.post(`${REPOSITORY_URL}/crear_concepto`, data);
  },

  actualizarConcepto(idConcepto, tipo, nombre) {
    let data = {
      idConcepto,
      tipo,
      nombre,
    };
    return ApiService.post(`${REPOSITORY_URL}/actualizar_concepto`, data);
  },

  listaConceptos() {
    return ApiService.get(`${REPOSITORY_URL}/lista_concepto`);
  },

  crearSubConcepto(
    idConcepto,
    codigo,
    esRelacionadoProduccion,
    indicarParcela,
    nombre
  ) {
    let data = {
      idConcepto,
      codigo,
      esRelacionadoProduccion,
      indicarParcela,
      nombre,
    };
    return ApiService.post(`${REPOSITORY_URL}/crear_subconcepto`, data);
  },

  actualizarSubConcepto(
    idSubconcepto,
    idConcepto,
    codigo,
    esRelacionadoProduccion,
    indicarParcela,
    nombre
  ) {
    let data = {
      idSubconcepto,
      idConcepto,
      codigo,
      esRelacionadoProduccion,
      indicarParcela,
      nombre,
    };
    return ApiService.post(`${REPOSITORY_URL}/actualizar_subconcepto`, data);
  },

  debajaSubConcepto(idSubconcepto) {
    let data = {
      idSubconcepto,
    };
    return ApiService.post(`${REPOSITORY_URL}/debaja_subconcepto`, data);
  },

  listaSubConceptos() {
    return ApiService.get(`${REPOSITORY_URL}/lista_subconcepto`);
  },

  // Tipo Movimiento Animal
  listaTipoMovimientoAnimal() {
    return ApiService.get(`${REPOSITORY_URL}/lista_tipo_mov_animal`);
  },

  agregarTipoMovimientoAnimal(
    codigo,
    tipo,
    nombre,
    indicarImporte,
    relacionMovFinanciero
  ) {
    let data = {
      codigo,
      tipo,
      indicarImporte,
      nombre,
      relacionMovFinanciero,
    };
    return ApiService.post(`${REPOSITORY_URL}/crear_tipo_mov_animal`, data);
  },

  actualizarTipoMovimientoAnimal(
    idTipoMovimientoAnimal,
    codigo,
    tipo,
    nombre,
    indicarImporte,
    relacionMovFinanciero
  ) {
    let data = {
      idTipoMovimientoAnimal,
      codigo,
      tipo,
      indicarImporte,
      nombre,
      relacionMovFinanciero,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/actualizar_tipo_mov_animal`,
      data
    );
  },

  borrarTipoMovimientoAnimal(idTipoMovimientoAnimal) {
    let data = {
      idTipoMovimientoAnimal,
    };
    return ApiService.post(`${REPOSITORY_URL}/borrar_tipo_mov_animal`, data);
  },

  // Categoria Animal
  listaCategoriaAnimal() {
    return ApiService.get(`${REPOSITORY_URL}/lista_categoria_animal`);
  },

  agregarCategoriaAnimal(clasificacion, sexo, nombre) {
    let data = {
      clasificacion,
      sexo,
      nombre,
    };
    return ApiService.post(`${REPOSITORY_URL}/crear_categoria_animal`, data);
  },

  actualizarCategoriaAnimal(idCategoriaAnimal, clasificacion, sexo, nombre) {
    let data = {
      idCategoriaAnimal,
      clasificacion,
      sexo,
      nombre,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/actualizar_categoria_animal`,
      data
    );
  },

  borrarCategoriaAnimal(idCategoriaAnimal) {
    let data = {
      idCategoriaAnimal,
    };
    return ApiService.post(`${REPOSITORY_URL}/borrar_categoria_animal`, data);
  },

  // Subcategoria Animal
  listaSubCategoriaAnimal() {
    return ApiService.get(`${REPOSITORY_URL}/lista_subcategoria_animal`);
  },

  agregarSubCategoriaAnimal(idCategoriaAnimal, esReproductivo, nombre) {
    let data = {
      idCategoriaAnimal,
      esReproductivo,
      nombre,
    };
    return ApiService.post(`${REPOSITORY_URL}/crear_subcategoria_animal`, data);
  },

  actualizarSubCategoriaAnimal(
    idSubcategoriaAnimal,
    idCategoriaAnimal,
    esReproductivo,
    nombre
  ) {
    let data = {
      idSubcategoriaAnimal,
      idCategoriaAnimal,
      esReproductivo,
      nombre,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/actualizar_subcategoria_animal`,
      data
    );
  },

  borrarSubCategoriaAnimal(idSubcategoriaAnimal) {
    let data = {
      idSubcategoriaAnimal,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/borrar_subcategoria_animal`,
      data
    );
  },

  // Parametro Recategorización
  crearParametroRecategorizacion(
    idTipoMovimientoAnimal,
    nombre,
    reglasRecategorizacion
  ) {
    let data = {
      idTipoMovimientoAnimal,
      nombre,
      reglasRecategorizacion,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/crear_param_recategorizacion`,
      data
    );
  },

  actualizarParametroRecategorizacion(
    idParametroRecategorizacion,
    idTipoMovimientoAnimal,
    nombre,
    reglasRecategorizacion
  ) {
    let data = {
      idParametroRecategorizacion,
      idTipoMovimientoAnimal,
      nombre,
      reglasRecategorizacion,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/actualizar_param_recategorizacion`,
      data
    );
  },

  borrarParametroRecategorizacion(idParametroRecategorizacion) {
    let data = {
      idParametroRecategorizacion,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/borrar_param_recategorizacion`,
      data
    );
  },

  listaTipoMovimientoRecategorizacion() {
    return ApiService.get(`${REPOSITORY_URL}/lista_tipo_mov_recategorizacion`);
  },

  listaParametrosRecategorizacion() {
    return ApiService.get(`${REPOSITORY_URL}/lista_param_recategorizacion`);
  },

  //Lotes Animal
  listaLotesAnimal(idEstablecimiento) {
    let data = {
      idEstablecimiento,
    };
    return ApiService.get(`${REPOSITORY_URL}/lista_lote_animal`, data);
  },

  crearLoteAnimalPredeterminado(idAgricultor, idEstablecimiento) {
    let data = {
      idAgricultor,
      idEstablecimiento,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/crear_lote_animal_predeterminado`,
      data
    );
  },

  crearLoteAnimalPropio(idAgricultor, idEstablecimiento, lotes) {
    let data = {
      idAgricultor,
      idEstablecimiento,
      lotes,
    };
    return ApiService.post(`${REPOSITORY_URL}/crear_lote_animal_propio`, data);
  },

  actualizarLoteAnimalPropio(
    idLoteAnimal,
    idAgricultor,
    reproductivo,
    nombre,
    comentario
  ) {
    let data = {
      idLoteAnimal,
      idAgricultor,
      reproductivo,
      nombre,
      comentario,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/actualizar_lote_animal_propio`,
      data
    );
  },

  debajaLoteAnimalpropio(idLoteAnimal, idAgricultor) {
    let data = {
      idLoteAnimal,
      idAgricultor,
    };
    return ApiService.post(`${REPOSITORY_URL}/debaja_lote_animal_propio`, data);
  },

  // Metodos reproduccion
  listaMetodoReproduccion() {
    return ApiService.get(`${REPOSITORY_URL}/lista_metodo_reproduccion`);
  },

  crearMetodoReproduccion(nombre) {
    let data = {
      nombre,
    };
    return ApiService.post(`${REPOSITORY_URL}/crear_metodo_reproduccion`, data);
  },

  actualizarMetodoReproduccion(idMetodoReproduccion, nombre) {
    let data = {
      idMetodoReproduccion,
      nombre,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/actualizar_metodo_reproduccion`,
      data
    );
  },

  borrarMetodoReproduccion(idMetodoReproduccion) {
    let data = {
      idMetodoReproduccion,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/borrar_metodo_reproduccion`,
      data
    );
  },

  // Categoria reproduccion
  listaCategoriaReproduccion() {
    return ApiService.get(`${REPOSITORY_URL}/lista_categoria_reproduccion`);
  },

  crearCategoriaReproduccion(nombre) {
    let data = {
      nombre,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/crear_categoria_reproduccion`,
      data
    );
  },

  actualizarCategoriaReproduccion(idCategoriaReproduccion, nombre) {
    let data = {
      idCategoriaReproduccion,
      nombre,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/actualizar_categoria_reproduccion`,
      data
    );
  },

  debajaCategoriaReproduccion(idCategoriaReproduccion) {
    let data = {
      idCategoriaReproduccion,
    };
    return ApiService.post(
      `${REPOSITORY_URL}/debaja_categoria_reproduccion`,
      data
    );
  },

  // Finalizar fichas
  terminarFichaAgricola(idFichaAgricola) {
    let data = {
      idFichaAgricola,
    };
    return ApiService.post(`${REPOSITORY_URL}/terminar_ficha_agricola`, data);
  },

  terminarFichaGanadera(idFichaGanadera, abrirFichaNueva) {
    let data = {
      idFichaGanadera,
      abrirFichaNueva,
    };
    return ApiService.post(`${REPOSITORY_URL}/terminar_ficha_ganadera`, data);
  },

  // debaja ficha ganadera
  debajaFicha(idFichaGanadera) {
    let data = {
      idFichaGanadera,
    };
    return ApiService.post(`${REPOSITORY_URL}/debaja_ficha_ganadera`, data);
  },

  cambiarGrupoExplotacion(
    idEstablecimiento,
    idGrupoExplotacionActual,
    idGrupoExplotacionNuevo,
    idTemporada
  ) {
    let data = {
      idEstablecimiento,
      idGrupoExplotacionActual,
      idGrupoExplotacionNuevo,
      idTemporada,
    };

    return ApiService.post(`${REPOSITORY_URL}/cambiar_grupo_explotacion`, data);
  },
};

export default ConfiguracionRepository;
